import { Swiper, SwiperSlide } from 'swiper/react'
import InstaFeedCard from '../pages/home-page/home-page-widgets/InstaFeedCard'
import ScrollFade from './ScrollFade'

const VertelierLove = () => {
  return (
    <div className='w-full bg-[#330000] relative mb-[60px]'>
      <div className="bg-[url('/image_insta_feed_poster.svg')] h-auto w-full flex flex-col justify-center items-center px-5 lg:px-20 py-10">
        <div className=''>
          <ScrollFade>
            <div className=' flex justify-center items-center flex-col md:space-y-3 space-y-2 lg:space-y-5'>
              <h1 className='uppercase font-barlowNormal  text-[28px] mb-md:text-[32px] mb-lg:text-[42px] switch:text-[54px] md:text-[64px] tracking-[8px] leading-[40px] text-[#E0B482]'>
                Insta<span className='font-barlowMedium'>gram</span>
              </h1>
              <h1 className='uppercase  font-barlowNormal mb-md:text-[17px] mb-lg:text-[19px] switch:text-[21px] lg:text-[32px] tracking-[5px] text-[#E0B482]'>
                Glam & Gram
              </h1>
              <p className=' font-barlowExtraLight text-[14px] mb-md:text-[16px] mb-lg:text-[18px] max-w-[940px] px-5 switch:px-0 switch:text-[20px] md:text-[24px] text-center'>
              Discover the essence of Vertelier passion and artistry in every nuance.
              Follow us on Instagram for an exclusive preview.
              </p>
            </div>
          </ScrollFade>
          <Swiper
            breakpoints={{
              0: {
                slidesPerView: 1.5,
                spaceBetween: 20,
              },
              640: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 36,
              },
            }}
            className='mt-10 lg:max-w-[1280px] w-screen'
          >
            <SwiperSlide className='h-full'>
              <InstaFeedCard
                image='https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/Essential_Page/image_model_one.png'
                url='https://www.instagram.com/reel/DCCI4fNt-Eo/?utm_source=ig_web_button_share_sheet&igsh=MzRlODBiNWFlZA=='
              />
            </SwiperSlide>
            <SwiperSlide className='h-full'>
              <InstaFeedCard
                image='https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/Essential_Page/image_insta_feed2.png'
                url='https://www.instagram.com/reel/DBq1474P5aV/?utm_source=ig_web_button_share_sheet&igsh=MzRlODBiNWFlZA=='
              />
            </SwiperSlide>
            <SwiperSlide className='h-full'>
              <InstaFeedCard
                image='https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/Essential_Page/image_insta_feed3.png'
                url='https://www.instagram.com/reel/DCCI4fNt-Eo/?utm_source=ig_web_button_share_sheet&igsh=MzRlODBiNWFlZA=='
              />
            </SwiperSlide>
            <SwiperSlide className='h-full'>
              <InstaFeedCard
                image='https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/Essential_Page/image_insta_feed4.png'
                url='https://www.instagram.com/reel/DBq1474P5aV/?utm_source=ig_web_button_share_sheet&igsh=MzRlODBiNWFlZA=='
              />
            </SwiperSlide>
          </Swiper>
        </div>
        <div className="flex justify-center items-center bg-[#FFFFFF] px-[16px] py-[12px] w-full max-w-[280px] md:max-w-[500px]   rounded-[8px] mt-10">
            <img src='/instagram.png'/>
            <span className='text-[16px] font-barlowBold text-[#A08260] ms-2'>Follow us on Instagram</span>
        </div>
      </div>
    </div>
  )
}

export default VertelierLove
